import React, { useEffect, useRef, useState } from "react";

import {
  Modal,
  Box,
  Typography,
  Autocomplete,
  Backdrop,
  TextField,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";

import CloseIcon from "@mui/icons-material/Close";
import { Btn } from "../../AbstractElements";
import { useDispatch, useSelector } from "react-redux";
import {
  getProcessesStatusList,
  getProcessesStatusListByNOA,
} from "../../store/process/actions";

import ConfirmModal from "../CGITrackingNew/ConfirmModal";
import { ShowError } from "../../_helper/helper";
import { getBBMRAnalyst } from "./slices/ggTrackSlice";
import { MultiColumnComboBox } from "@progress/kendo-react-dropdowns";
import { filterBy } from "@progress/kendo-data-query";
import { BBMRBulkUpdate } from "./slices/TransactionDataSlice";
import zIndex from "@mui/material/styles/zIndex";

const DeptAdmin = "Dept Admin";
const Submitted = "Submitted";
const CertOfficer = "Cert Officer";
const AgencyDirector = "Agency Director";
const BBMR = "BBMR";
const AssignAnalyst = "Assign Analyst";
const AnalystReview = "Analyst Review";
const SupervisorReview = "Supervisor Review";
const AdminStaffReview = "Admin Staff Review";
const DirectorReview = "Director Review";
const AdminStaffRouting = "Admin Staff Routing";
const Classification = "Classification";
const Recruitment = "Recruitment";
const EMR = "EMR";
const DrugTesting = "Drug Testing";
const Records = "Records";

const BulkStatusChangeModalBBMR = (props) => {
  const [status, setStatus] = useState("");

  const [approve, setApprove] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [prevStatus, setPrevStatus] = useState({ value: 0, label: "" });
  const [nextStatus, setNextStatus] = useState({ value: 0, label: "" });
  const dispatch = useDispatch();

  const remarkRef = useRef();
  // const { processStatusList } = props;

  const { processStatusList } = useSelector((state) => state.processReducer);
  const [openConfirmation, setOpenConfirmation] = useState(false);
 
  const [returnState, setReturnState] = useState();
  const [forwardState, setForwardState] = useState();
  const [showDropdown, setShowDropdown] = useState(false);
  const [showAnalyst, setShowAnalyst] = useState(false);
  const [filteredReturnArray, setFilteredReturnArray] =
    useState([]);
  const [filteredForwardArray, setFilteredForwardArray] =
    useState([]);
  const [currentProcessItem, setCurrentProcessItem] = useState();
  // const recordsSeq = processStatusList?.filter((item)=> item?.id == 19)?.seq;
  const [lastSeq, setLastSeq] = useState(12);

  const [BBMRAnalyst, setBBMRAnalyst] = useState();

  const [BBMRList, setBBMRList] = useState([]);

  const { BBMRList: analystList, isBBMRLoading } = useSelector(
    (state) => state.ggTrackSlice
  );
 
  useEffect(()=>{
    if(!processStatusList?.length){
      dispatch(getProcessesStatusList(1));
    }
  },[processStatusList])

  useEffect(() => {
    if(!analystList?.length){
      dispatch(getBBMRAnalyst()); 
    }
  }, []);
  useEffect(() => {
    if (analystList.length) {
      setBBMRList(
        analystList
      );
    }
  }, [analystList]);

  useEffect(()=>{
    let newProcessList = processStatusList;
    let classificationSeq;
    let ignoreIdList = [18,6,338,344,340,343]

    let newLastSeq = lastSeq;
    if (newProcessList && newProcessList.length) {
      classificationSeq = newProcessList.find(
        (item) => item?.statusName == "Classification"
      )?.seq;
      setLastSeq(classificationSeq);



      if(props?.role == "BBMR-ADMIN"){
        let seq1 = newProcessList.find(
          (item) => item?.statusName == "Analyst Review"
        )?.seq;
        newLastSeq = seq1;
        setLastSeq(seq1)
      } else if(props?.role == "BBMR-ANALYST"){
        let seq1 = newProcessList.find(
          (item) => item?.statusName == "Supervisor Review"
        )?.seq
        newLastSeq = seq1;
        setLastSeq(seq1)
      } else if(props?.role == "BBMR-SUPERVISOR"){
        let seq1 = newProcessList.find(
          (item) => item?.statusName == "Director Review"
        )?.seq
        newLastSeq = seq1;
        setLastSeq(seq1)
      } else if(props?.role == "BBMR-DIRECTOR"){
        let seq1 = newProcessList.find(
          (item) => item?.statusName == "Classification"
        )?.seq
        newLastSeq = seq1;
        setLastSeq(seq1)
      }
    }

      let forwardItems = newProcessList
        .filter((d) => d.seq <= newLastSeq && !ignoreIdList.includes(d?.id))
        .map((d) => {
          return { value: d.id, label: d.statusName };
        });
    
      let newArray = [...forwardItems];
      
      // console.log("123123 ::: ", forwardItems, newArray, newLastSeq, lastSeq);
      // setForwardState(forwardItems[0]);
      // setFilteredForwardArray(forwardItems);
      // setForwardState(newArray[0]);
      setFilteredForwardArray(newArray);
    

  },[processStatusList])

  const columns = [
    {
      field: "EmployeeID",
      header: "Emp ID",
      width: "130px",
    },
    {
      field: "EmployeeName_LFM",
      header: "Name",
      width: "200px",
    },
    {
      field: "DivisionName",
      header: "Department",
      width: "300px",
    },
    {
      field: "TotalAssigned",
      header: "Total Assigned",
      width: "150px",
    },
  ];
  const [filter, setFilter] = React.useState();
  
  const handleFilterChange = (event) => {
    if (event) {
      const value = event.filter.value.toLowerCase();
      setFilter({
        logic: "or",
        filters: columns.map((column) => ({
          field: column.field,
          operator: "contains",
          value,
        })),
      });
    }
  };
/****************** */
  
  const handleSubmit = () => {
    // console.log("123123 state ======== ",forwardState, CheckValue(BBMRAnalyst))
    if ((forwardState?.value == 342 || forwardState?.value == 272) &&
      !CheckValue(BBMRAnalyst) &&
      approve
    ) {
      ShowError("Please Assign Any BBMR Analyst");
      return false;
    }
    setOpenConfirmation(true);
  };
  const CheckValue = (temp) => {
    if (temp !== null && temp !== undefined && temp !== "") {
      return true;
    }
    return false;
  };

  const onConfirm = () => {
    if(((forwardState?.value == undefined || forwardState?.value == "0")) ){
      ShowError("Please Select Send To");
      return false;
    } 
    let payload = {
      hrcontrol: props?.selectedTransactions?.join(","),
      currentProcessStatus: forwardState?.value,
      analyst: BBMRAnalyst ? BBMRAnalyst?.EmployeeID : 0,
      remarks: remarks
    }
    if (approve) {
      dispatch(BBMRBulkUpdate({ payload }))
    } 
    setTimeout(() => {
      props.setSelectedList([]);
      setOpenConfirmation(false);
      props.handleClose();
      window.location.reload();
    }, 1000);
  };
  // console.log("123123123 === ",props?.selectedTransactions)
  return (
    <div>
      <Dialog open={props.isOpen} onClose={props.handleClose} fullWidth>
        <DialogTitle>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            Total: {props?.selectedTransactions?.length} Transactions Selected
            <IconButton onClick={props.handleClose}>
              <CloseIcon />
            </IconButton>
          </div>
          {/* <Typography>
            <h5>
              Status Changed to:{" "}
              <b>{props?.newProcessStatus?.label || nextStatus?.label}</b>
            </h5>
          </Typography> */}
        </DialogTitle>
        <DialogContent>
          {/* {console.log("112112 ::: ",currentProcessItem, lastSeq)} */}
          <FormControl>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
            >
              {/* {(props?.currentStatus?.value == 19 && props?.isGG1Transaction) ||
              props?.currentStatus?.value != 135 ? null : ( */}
              {(props?.currentStatus?.value == 19 && props?.isGG1Transaction) ||
              props?.currentStatus?.value == 135 ||
              currentProcessItem?.seq == lastSeq ? null : (
                <FormControlLabel
                  value="Approve"
                  control={
                    <Radio
                      onChange={(e, v) => {
                        setStatus(e.target.value);
                        setApprove(true);
                        setShowDropdown(true);
                      }}
                      checked={
                        status && status.trim() == "Approve" ? true : false
                      }
                    />
                  }
                  label={`Send to ${forwardState?.label ? forwardState?.label : ""}`} //"Approve"
                />
              )}
            </RadioGroup>
          </FormControl>
          {approve && showDropdown ?
          (
            <Autocomplete
              size="small"
              name="ReturnStatus"
              InputLabelProps={{
                shrink: true,
              }}
              id="CurrentProcessStatus"
              disableClearable={true}
              value={forwardState}
              // options={returnFromArray}
              options={filteredForwardArray}
              getOptionLabel={(option) =>
                option.label ? option.label?.toString() : ""
              }
              onChange={(e, v) => {
                setForwardState(v);
                if(v?.value == 342 || v?.value ==272){
                  setShowAnalyst(true);
                }else{
                  setShowAnalyst(false)
                }
                // console.log("123123 forward",v,v?.value);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  label="Send To"
                />
              )}
            />
          ) : null}

          {showAnalyst ? 
            <MultiColumnComboBox
              // data={results}
              // data={filter ? filterBy(results, filter) : results}
              data={filter ? filterBy(BBMRList, filter) : BBMRList}
              filterable={true}
              onFilterChange={handleFilterChange}
              columns={columns}
              textField={"EmployeeName_LFM"}
              style={{
                width: "300px",
              }}
              popupSettings= {{ className: 'k-list-container' }}
              className="mt-3 mb-3"
              placeholder="Select Analyst"
              onChange={(e) => 
                {
                  setBBMRAnalyst(e.target.value)
                }
              }
            />
          :null}

          <TextField
            margin="dense"
            variant="outlined"
            style={{ width: "100%" }}
            size="small"
            label="Remarks"
            multiline={true}
            rows={4}
            InputLabelProps={{
              shrink: true,
            }}
            // className="flex w-full mx-10"
            onChange={(e) => {
              setRemarks(e.target.value);
            }}
            error={remarkRef?.current?.childNodes[0].value == status?.trim()}
            className={`flex w-full mx-10 ${
              remarkRef?.current?.childNodes[0].value == status?.trim()
                ? "hasErrorLbl"
                : ""
            } `}
          />
          
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", marginBottom: "10px" }}>
          <Btn
            attrBtn={{
              color: "primary",
              onClick: () => {
                if (remarks?.trim() !== "" || approve) {
                  handleSubmit();
                }
              }, 
              disabled: !status,
              // props.handleClose
            }}
          >
            Submit
          </Btn>
        </DialogActions>
      </Dialog>
      {openConfirmation && (
        <ConfirmModal
          open={openConfirmation}
          setOpen={setOpenConfirmation}
          confimClick={onConfirm}
          cnfrmBtnName="Yes"
          cancelBtnName="No"
          message={"Are you sure to make this change?"}
          // modalHeader="Alert Message"
        />
      )}
    </div>
  );
};
export default BulkStatusChangeModalBBMR;
